import Accenture from './logos/Accenture'
import Adobe from './logos/Adobe'
import AI21 from './logos/AI21'
import AMD from './logos/AMD'
import AmericanAirlines from './logos/AmericanAirlines'
import Amplifon from './logos/Amplifon'
import Anthropic from './logos/Anthropic'
import ASOS from './logos/Asos'
import ATT from './logos/ATT'
import BlackForestLabs from './logos/BlackForestLabs'
import Bolt from './logos/Bolt'
import CarlsbergGroup from './logos/CarlsbergGroup'
import CocaCola from './logos/CocaCola'
import Cohere from './logos/Cohere'
import Cognizant from './logos/Cognizant'
import Coinbase from './logos/Coinbase'
import CoyoteLogistics from './logos/CoyoteLogistics'
import Datadog from './logos/Datadog'
import Decathlon from './logos/Decathlon'
import DeepSeek from './logos/DeepSeek'
import DeutcheVermögensberatung from './logos/DeutcheVermögensberatung'
import Docusign from './logos/Docusign'
import Doctolib from './logos/Doctolib'
import DowJones from './logos/DowJones'
import Duolingo from './logos/Duolingo'
import EclipseIDE from './logos/EclipseIDE'
import Elanco from './logos/Elanco'
import ErnstAndYoung from './logos/ErnstAndYoung'
import Etched from './logos/Etched'
import Etsy from './logos/Etsy'
import Evolent from './logos/Evolent'
import FedEx from './logos/FedEx'
import Fidelity from './logos/Fidelity'
import Ford from './logos/Ford'
import GeneralMotors from './logos/GeneralMotors'
import Google from './logos/Google'
import GrupoBoticario from './logos/GrupoBoticario'
import GitHub from './logos/GitHub'
import Hashicorp from './logos/Hashicorp'
import Hebbia from './logos/Hebbia'
import HM from './logos/HM'
import HomeDepot from './logos/HomeDepot'
import HP from './logos/HP'
import HSBC from './logos/HSBC'
import Infosys from './logos/Infosys'
import Intel from './logos/Intel'
import Itau from './logos/Itau'
import JetBrains from './logos/JetBrains'
import Kpmg from './logos/Kpmg'
import LinkedIn from './logos/LinkedIn'
import MercadoLibre from './logos/MercadoLibre'
import MercedesBenz from './logos/MercedesBenz'
import Meta from './logos/Meta'
import Microsoft from './logos/Microsoft'
import MistralAI from './logos/MistralAI'
import Nasa from './logos/Nasa'
import Neovim from './logos/Neovim'
import OpenAI from './logos/OpenAI'
import OttoGroup from './logos/OttoGroup'
import Philips from './logos/Philips'
import PhysicalIntelligence from './logos/PhysicalIntelligence'
import Plaid from './logos/Plaid'
import Postmates from './logos/Postmates'
import ProcterAndGamble from './logos/ProcterAndGamble'
import Raycast from './logos/Raycast'
import Shopify from './logos/Shopify'
import SocieteGenerale from './logos/SocieteGenerale'
import SPGlobalMarketIntelligence from './logos/SPGlobalMarketIntelligence'
import Spotify from './logos/Spotify'
import Stripe from './logos/Stripe'
import SurgeAI from './logos/SurgeAI'
import Telus from './logos/Telus'
import ThreeM from './logos/ThreeM'
import Twilio from './logos/Twilio'
import Vercel from './logos/Vercel'
import VisualStudio from './logos/VisualStudio'
import VisualStudioCode from './logos/VisualStudioCode'
import Vodafone from './logos/Vodafone'
import WEX from './logos/Wex'
import xAI from './logos/XAI'
import Xcode from './logos/Xcode'
import Azure from './logos/Azure'
import Zendesk from './logos/Zendesk'

/**
 * Render SVG logo as React component.
 *
 * When adding a new logo:
 * - It's safe to remove the fill property because Logo Suite sets that property via CSS.
 * - Logos must have a <title> tag for accessibility.
 * - If an SVG has className such as `st0` or `st1`, namespace the class to avoid conflicts. e.g. from .sg0 to .company-sg0
 * - If a single logo doesn't look aligned compared to the surrounding logos, consider experimenting with margin (directly on the SVG) to align it.
 * - Pro tip: If you're given a figma file, you can right click on the logo and copy the SVG code directly.
 */
export const LogoSuiteMap: {[key: string]: () => React.ReactElement} = {
  Accenture,
  '3M': ThreeM,
  Adobe,
  'AI21 Labs': AI21,
  'American Airlines': AmericanAirlines,
  AMD,
  Anthropic,
  Amplifon,
  ASOS,
  'AT&T': ATT,
  'Black Forest Labs': BlackForestLabs,
  Bolt,
  'Carlsberg Group': CarlsbergGroup,
  'Coca-Cola': CocaCola,
  Cohere,
  Cognizant,
  'Coyote Logistic': CoyoteLogistics,
  Coinbase,
  Datadog,
  Decathlon,
  DeepSeek,
  'Deutsche Vermögensberatung': DeutcheVermögensberatung,
  Doctolib,
  DocuSign: Docusign,
  Duolingo,
  'Dow Jones': DowJones,
  'Eclipse IDE': EclipseIDE,
  'Ernst and Young': ErnstAndYoung,
  Etched,
  Elanco,
  Etsy,
  Evolent,
  FedEx,
  Ford,
  Fidelity,
  'General Motors': GeneralMotors,
  GitHub,
  Google,
  'Grupo Boticário': GrupoBoticario,
  Hashicorp,
  Hebbia,
  'Home Depot': HomeDepot,
  HP,
  HSBC,
  'H&M': HM,
  Infosys,
  Intel,
  Itau,
  JetBrains,
  KPMG: Kpmg,
  LinkedIn,
  'Mercado Libre': MercadoLibre,
  'Mercedes Benz': MercedesBenz,
  Meta,
  Microsoft,
  'Mistral AI': MistralAI,
  Nasa,
  Neovim,
  OpenAI,
  'Otto Group': OttoGroup,
  Plaid,
  Philips,
  'Physical Intelligence': PhysicalIntelligence,
  Postmates,
  'Procter and Gamble': ProcterAndGamble,
  Raycast,
  Shopify,
  'Societe Generale': SocieteGenerale,
  'S&P Global Market Intelligence': SPGlobalMarketIntelligence,
  Spotify,
  Stripe,
  SurgeAI,
  Telus,
  Twilio,
  Vercel,
  'Visual Studio': VisualStudio,
  'Visual Studio Code': VisualStudioCode,
  Vodafone,
  WEX,
  Xcode,
  Azure,
  xAI,
  Zendesk,
}

export const Logo = ({name}: {name: string}) => {
  const Component = LogoSuiteMap[name]
  if (Component) {
    return <Component />
  }
  return null
}
